import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import { useQuery } from 'data-fetching-client';
import Raven from 'raven-js';
import { CRM_SEARCH_BY_ID_FIELD_NAME, GET_CRM_SEARCH_OBJECT_BY_ID } from 'flow-doctor-lib/queries/CrmObjectQueries';
import { getPropertyForObject, getUrlForObjectTypeId } from 'flow-doctor-lib/utils/objectUtils';
import SkeletonText from 'flow-doctor-lib/components/common/SkeletonText';
import { jsx as _jsx } from "react/jsx-runtime";
const ViewRecordLink = ({
  enrollmentEvent
}) => {
  // We only need to query for user based workflow enrollments
  const skipQuery = !['0-115', '0-11'].includes(enrollmentEvent.objectTypeId);
  const {
    loading,
    error,
    data
  } = useQuery(GET_CRM_SEARCH_OBJECT_BY_ID, {
    variables: {
      portalId: enrollmentEvent.portalId,
      objectTypeId: enrollmentEvent.objectTypeId,
      objectId: enrollmentEvent.objectId.toString()
    },
    skip: skipQuery
  });
  let userId;
  let threadId;
  if (!skipQuery) {
    var _data$CRM_SEARCH_BY_I;
    if (loading || !data) {
      return /*#__PURE__*/_jsx(SkeletonText, {});
    }
    if (error) {
      Raven.captureMessage('Error fetching user information', {
        extra: {
          error
        }
      });
    }
    const objectResponse = (_data$CRM_SEARCH_BY_I = data[CRM_SEARCH_BY_ID_FIELD_NAME]) === null || _data$CRM_SEARCH_BY_I === void 0 || (_data$CRM_SEARCH_BY_I = _data$CRM_SEARCH_BY_I.results) === null || _data$CRM_SEARCH_BY_I === void 0 ? void 0 : _data$CRM_SEARCH_BY_I[0];
    userId = getPropertyForObject(objectResponse, 'hs_internal_user_id');
    threadId = getPropertyForObject(objectResponse, 'hs_thread_id');
  }
  const recordHref = getUrlForObjectTypeId({
    portalId: enrollmentEvent.portalId,
    objectTypeId: enrollmentEvent.objectTypeId,
    objectId: enrollmentEvent.objectId,
    userId: userId ? Number(userId) : undefined,
    threadId: threadId ? Number(threadId) : undefined
  });
  return /*#__PURE__*/_jsx(UILink, {
    external: true,
    href: recordHref || undefined,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-lib.flows.objectLifecycle.actions.viewRecord"
    })
  });
};
export default ViewRecordLink;